import { zipWith } from 'lodash'

export default async function (editorSdkProxy) {
  const controllers = await editorSdkProxy.controllers.listControllers()
  const controllerRefs = controllers.map(c => c.controllerRef)

  const controllersData = await Promise.all(
    controllerRefs.map(controllerRef =>
      editorSdkProxy.controllers.getData({ controllerRef }),
    ),
  )

  return zipWith(
    controllerRefs,
    controllersData,
    (controllerRef, controllerData) => ({
      ...controllerData,
      controllerRef,
    }),
  )
}
